module.exports = __webpack_public_path__ + "img/4.87397420.png";